/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Oś filtra Status planu (liczona względem aktywnego cyklu).
 * @export
 * @enum {string}
 */

export const TeamPlanStatusFilterDto = {
    All: 'ALL',
    Approved: 'APPROVED',
    Waiting: 'WAITING',
    Overdue: 'OVERDUE',
    Draft: 'DRAFT',
    None: 'NONE'
} as const;

export type TeamPlanStatusFilterDto = typeof TeamPlanStatusFilterDto[keyof typeof TeamPlanStatusFilterDto];



